import React, { useEffect } from 'react';
import { Outlet, useLocation, useSearchParams } from 'react-router-dom';
import Footer from '../components/footer/Footer';
import { IS_IN_PURCHASE, localStorageKeys, ROOT_PATHNAME } from '../utils/Constants';
import { isReactNativeWebView } from '../utils/reactNativeUtils';
import { useWebViewAutoSignIn } from './useWebViewAuth';

const MainContainer = () => {
    const location = useLocation();
    const isShow = ROOT_PATHNAME.includes(location.pathname) && !isReactNativeWebView();
    const [searchParams] = useSearchParams();

    // WebViewからアクセスした時の自動ログイン
    const { autoSignIn, isInitialized } = useWebViewAutoSignIn();

    useEffect(() => {
        if (isInitialized) {
            return;
        }
        void autoSignIn();
    }, [autoSignIn, isInitialized]);

    useEffect(() => {
        // 購入処理が中断されたとみなす。
        const isInPurchase = localStorage.getItem(IS_IN_PURCHASE);
        const loginFlow = localStorage.getItem(localStorageKeys.LOGIN_FLOW);
        if (isInPurchase || loginFlow) {
            localStorage.removeItem(IS_IN_PURCHASE);
            localStorage.removeItem(localStorageKeys.LOGIN_FLOW);
        }
        return () => {};
    }, [searchParams]);

    return (
        <>
            <Outlet />
            <Footer isShow={isShow} />
        </>
    );
};

export default MainContainer;
